export const CLAIM_CACHE_TTL = 30 * 60 * 1000;

class LocalStorageManager {
    private static instance: LocalStorageManager;

    private constructor() {}

    // Lấy instance duy nhất
    static getInstance() {
        if (!LocalStorageManager.instance) {
            LocalStorageManager.instance = new LocalStorageManager();
        }
        return LocalStorageManager.instance;
    }

    // Lấy giá trị (tự JSON.parse)
    get<T = any>(key: string, defaultValue: T | null = null): T | null {
        try {
            const raw = localStorage.getItem(key);
            if (raw === null) return defaultValue;
            return JSON.parse(raw) as T;
        } catch {
            return defaultValue;
        }
    }

    setWithExpiry(key: string, value: any, ttlMs: number) {
        const item = {
            value,
            expiry: Date.now() + ttlMs,
        };
        localStorage.setItem(key, JSON.stringify(item));
    }

    // Lấy data — nếu hết hạn thì xóa, return null
    getWithExpiry<T = any>(key: string): T | null {
        try {
            const raw = localStorage.getItem(key);
            if (!raw) return null;

            const item = JSON.parse(raw);

            if (Date.now() > item.expiry) {
                localStorage.removeItem(key);
                return null;
            }

            return item.value as T;
        } catch {
            return null;
        }
    }

    // Set giá trị (tự JSON.stringify)
    set<T = any>(key: string, value: T) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    // Xóa 1 key
    remove(key: string) {
        localStorage.removeItem(key);
    }

    // Clear toàn bộ localStorage
    clearAll() {
        localStorage.clear();
    }
}

// 🔥 Export luôn instance duy nhất để dùng
export const storage = LocalStorageManager.getInstance();
